import React from 'react';
import PatientLabelDialog from './Dialogs/PatientLabelDialog';
import ShippingLabelDialog from './Dialogs/ShippingLabelDialog';
import BundleCompletionDialog from './Dialogs/BundleCompletionDialog';

const ShipmentDialog = () => {
  return (
    <>
      <PatientLabelDialog />
      <ShippingLabelDialog />
      <BundleCompletionDialog />
    </>
  );
};

ShipmentDialog.propTypes = {};

export default ShipmentDialog;
